/* predictive-search.js — header search suggestions via /search/suggest.json */
(function () {
  'use strict';
  const theme = window.theme || {};

  document.querySelectorAll('[data-predictive-search]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const panel = form.querySelector('[data-search-results]');
    if (!input || !panel) return;

    let timer = null;
    let activeIndex = -1;
    let abort = null;

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');

    const close = () => {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    };

    const options = () => Array.from(panel.querySelectorAll('[data-search-option]'));

    const highlight = (idx) => {
      const opts = options();
      opts.forEach((o, i) => o.classList.toggle('is-active', i === idx));
      activeIndex = idx;
      if (opts[idx]) opts[idx].scrollIntoView({ block: 'nearest' });
    };

    const esc = (s) =>
      String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

    const render = (data, terms) => {
      const products = (((data.resources || {}).results || {}).products || []).slice(0, 6);
      const searchUrl = (theme.routes && theme.routes.search ? theme.routes.search : '/search') + '?q=' + encodeURIComponent(terms);
      const seeAll = ((theme.strings && theme.strings.searchFor) || 'Search for “__TERMS__”').replace('__TERMS__', esc(terms));

      const items = products
        .map(
          (p) => `
        <a class="search-suggestion" data-search-option href="${esc(p.url)}">
          ${p.image ? `<img src="${esc(p.image)}&width=80" alt="" width="40" height="40" loading="lazy">` : '<span class="search-suggestion__noimg"></span>'}
          <span class="search-suggestion__title">${esc(p.title)}</span>
          <span class="search-suggestion__price">${p.price ? esc(p.price) : ''}</span>
        </a>`
        )
        .join('');

      panel.innerHTML = `${items}<a class="search-suggestion search-suggestion--all" data-search-option href="${searchUrl}">${seeAll}</a>`;
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      activeIndex = -1;
    };

    input.addEventListener('input', () => {
      const terms = input.value.trim();
      window.clearTimeout(timer);
      if (terms.length < 2) {
        close();
        return;
      }
      timer = window.setTimeout(() => {
        if (abort) abort.abort();
        abort = new AbortController();
        const base = theme.routes && theme.routes.predictiveSearch ? theme.routes.predictiveSearch : '/search/suggest';
        fetch(`${base}.json?q=${encodeURIComponent(terms)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, {
          signal: abort.signal,
        })
          .then((r) => r.json())
          .then((data) => render(data, terms))
          .catch(() => {});
      }, 250);
    });

    input.addEventListener('keydown', (e) => {
      if (panel.hidden) return;
      const opts = options();
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        highlight(Math.min(activeIndex + 1, opts.length - 1));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        highlight(Math.max(activeIndex - 1, 0));
      } else if (e.key === 'Enter' && activeIndex >= 0 && opts[activeIndex]) {
        e.preventDefault();
        opts[activeIndex].click();
      } else if (e.key === 'Escape') {
        close();
        input.focus();
      }
    });

    document.addEventListener('click', (e) => {
      if (!form.contains(e.target)) close();
    });
  });
})();
